import { Box, Stack } from "@mui/material";

import APAccordion from "../../../components/APAccordion";
import { VehiclePricingRequest } from "../../../types/VehiclePricingRequest";
import PricingRequestCard from "./PricingRequestCard";

const PricingRequestList = ({
  requests,
  type,
  crmClientURL,
  columns = "single",
  defaultExpanded = true,
  showUseQuoteButton = false,
  onUseQuote,
  displayType,
  cardType,
}: {
  requests: VehiclePricingRequest[];
  type: "requested" | "received";
  crmClientURL: string | null;
  displayType: "accordion" | "list";
  cardType: "quote-specific" | "generic";
  columns?: "single" | "double" | "triple";
  defaultExpanded?: boolean;
  showUseQuoteButton?: boolean;
  onUseQuote?: (pricingRequest: VehiclePricingRequest) => Promise<void>;
}) => {
  const title = type === "requested" ? "Pricing Requested" : "Pricing Received";
  const badgeCount = requests.length;

  const renderPricingRequests = (requests: VehiclePricingRequest[]) => {
    return requests.map((request) => (
      <Box key={request.id}>
        <PricingRequestCard
          pricingRequest={request}
          actions={{
            onUseQuote: onUseQuote,
          }}
          config={{
            crmClientURL: crmClientURL,
            showUseQuoteButton: showUseQuoteButton,
            type: cardType,
          }}
        />
      </Box>
    ));
  };

  const gridTemplateColumns = {
    single: "1fr",
    double: { md: "1fr 1fr" },
    triple: { md: "1fr 1fr", lg: "1fr 1fr 1fr" },
  };

  const renderRequests = () => {
    return (
      <Stack
        spacing={0}
        sx={{
          display: columns === "single" ? "flex" : "grid",
          gap: 1,
          gridTemplateColumns: gridTemplateColumns[columns],
        }}
      >
        {renderPricingRequests(requests)}
      </Stack>
    );
  };

  return displayType === "accordion" ? (
    <APAccordion
      title={title}
      badgeCount={badgeCount}
      defaultExpanded={defaultExpanded}
    >
      {renderRequests()}
    </APAccordion>
  ) : (
    renderRequests()
  );
};

export default PricingRequestList;
